
export { Sam2ImageProcessor as Sam3ImageProcessor } from '../sam2/image_processing_sam2.js';
